import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const setInitialData = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.upsert.data = data;
  });
};

const change = (store, event) => {
  store.setState((state) => {
    state.app.usuarios.upsert = {
      ...state.app.usuarios.upsert,
      ...event,
    };
  });
};

const upsert = async (store, data, id) => {
  store.setState((state) => {
    state.app.usuarios.upsert.busy = true;
  });

  try {
    let response = !!id ? await Http.put(`api/usuarios/${id}`, data) : await Http.post(`api/usuarios`, data);

    store.setState((state) => {
      state.app.usuarios.upsert.result = response;
      state.app.usuarios.upsert.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.upsert.error = error.data || error;
      state.app.usuarios.upsert.busy = false;
    });
  }
};

const upsertPermissions = async (store, data, id) => {
  store.setState((state) => {
    state.app.usuarios.upsert.busy = true;
  });

  try {
    const response = await Http.put(`api/usuarios/${id}/permission`, data);

    store.setState((state) => {
      state.app.usuarios.upsert.result = response;
      state.app.usuarios.upsert.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.upsert.error = error.data || error;
      state.app.usuarios.upsert.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.usuarios.upsert = { ...initialState };
  });
};

const resetError = (store) => {
  store.setState((state) => {
    state.app.usuarios.upsert.error = null;
    state.app.usuarios.upsert.result = null;
  });
};

const setInfo = setInitialData;

const UsuarioUpsertStore = {
  state: () => initialState,
  actions: {
    setInitialData,
    upsertPermissions,
    setInfo,
    change,
    upsert,
    reset,
    resetError,
  },
};

export default UsuarioUpsertStore;
